// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uJUNzkOa3jVnmiel9OY3 {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: var(--campaign-card-max-width);
  height: var(--campaign-card-height);
  cursor: pointer;
  padding: var(--campaign-card-padding);
  flex-shrink: 0;
  border: 1px solid var(--campaign-color-primary);
  border-radius: var(--campaign-border-radius-md);
  transition: transform 0.15s ease, height 0.35s cubic-bezier(0.22, 1.2, 0.36, 1);
  /* Contain layout recalculations within the card during collapse animation.
       This prevents the height transition from triggering layout on siblings. */
  contain: layout style;
}
.uJUNzkOa3jVnmiel9OY3.r1k5PwDmr936zh0xYLyS {
  height: var(--campaign-card-collapsed-height);
  padding: var(--campaign-card-collapsed-padding);
}
.cJFMO5f_TkEKJyCDMgEu {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, var(--campaign-card-gradient-color) 0%, transparent 4%);
  border-radius: var(--campaign-border-radius-md);
  z-index: 0;
}
.cJFMO5f_TkEKJyCDMgEu[data-collapsed="true"] {
  background: linear-gradient(to top, var(--campaign-card-gradient-color) 0%, transparent 8%);
}
/* overflow: hidden clips content while scaleY animation is in progress. */
.uJUNzkOa3jVnmiel9OY3[data-animating="true"] {
  overflow: hidden;
}
/* Dark background masking during COLLAPSE only.
   On expand the new background image should be visible immediately.
   data-collapsing is set by useCollapseAnimation only when folding. */
.uJUNzkOa3jVnmiel9OY3[data-collapsing="true"] {
  background-color: var(--campaign-color-background-dark);
  background-image: linear-gradient(135deg, var(--campaign-color-background-dark) 0%, var(--campaign-color-background-dark) 100%);
  background-repeat: no-repeat;
  background-size: cover;
}
/* Fade the background image out during collapse so the card's
   dark background-color shows through (replicating the pre-release masking).
   contain: layout style creates a stacking context, so z-index:-1 no longer
   puts .backgroundImage behind the card's background — we hide it instead.
   Hide is instant (0s) to avoid a flash of the new asset; reveal fades in
   smoothly when data-collapsing is removed (base rule's 0.15s applies). */
.uJUNzkOa3jVnmiel9OY3[data-collapsing="true"][data-has-many="true"] .TD_JtFmIT0WGaT_0IEiI {
  opacity: 0;
  transition: opacity 0s;
}
.uJUNzkOa3jVnmiel9OY3[data-has-many="true"] .TD_JtFmIT0WGaT_0IEiI {
  transition: opacity 0.15s ease-in-out;
}
/* Add background-color transition for hasMany so the dark mask fades smoothly */
.uJUNzkOa3jVnmiel9OY3[data-has-many="true"] {
  transition: transform 0.15s ease, background-color 0.12s ease-in-out;
}
.uJUNzkOa3jVnmiel9OY3[data-animating="true"] .TD_JtFmIT0WGaT_0IEiI {
  background-repeat: no-repeat;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .uJUNzkOa3jVnmiel9OY3 {
    width: 100%;
    height: var(--campaign-card-height-mobile-portrait);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .uJUNzkOa3jVnmiel9OY3 {
    width: 100%;
    height: var(--campaign-card-height-mobile-portrait);
  }
}
}
}
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: landscape) {
  .uJUNzkOa3jVnmiel9OY3 {
    width: 100%;
    height: var(--campaign-card-height-mobile-landscape);
    background-size: contain;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: landscape) {
  .uJUNzkOa3jVnmiel9OY3 {
    width: 100%;
    height: var(--campaign-card-height-mobile-landscape);
    background-size: contain;
  }
}
}
}
}
.TD_JtFmIT0WGaT_0IEiI {
  position: absolute;
  inset: 0;
  z-index: -1;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-color: var(--campaign-card-background);
  border-radius: var(--campaign-border-radius-sm);
}
@keyframes U8ULl2KQzBN18EKzssE5 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
/* Outgoing layer for background crossfade during collapse/expand.
   Sits on top of the current image (later in DOM order, same z-index)
   and fades out to reveal the new image underneath. */
.gR4KQmZoGCYcuBbpl0A4 {
  opacity: 0;
  pointer-events: none;
  background-repeat: no-repeat;
}
.gR4KQmZoGCYcuBbpl0A4[data-fading="true"] {
  animation: U8ULl2KQzBN18EKzssE5 0.3s ease-in-out forwards;
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) {
  .TD_JtFmIT0WGaT_0IEiI {
    background-size: cover;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) {
  .TD_JtFmIT0WGaT_0IEiI {
    background-size: cover;
  }
}
}
}
}
@media (max-width: 374px) and (orientation: portrait) {
  .TD_JtFmIT0WGaT_0IEiI[data-collapsed="true"][data-has-many="true"] {
    background-size: contain;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (min-width: 500px) and (max-color:2147477350) and (orientation: portrait) {
  .TD_JtFmIT0WGaT_0IEiI {
    background-size: contain;
  }
  .TD_JtFmIT0WGaT_0IEiI[data-collapsed="true"][data-has-many="false"] {
    background-size: cover;
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (min-width: 500px) and (color:2147477350) and (orientation: portrait) {
  .TD_JtFmIT0WGaT_0IEiI {
    background-size: contain;
  }
  .TD_JtFmIT0WGaT_0IEiI[data-collapsed="true"][data-has-many="false"] {
    background-size: cover;
  }
}
}
}
}
@media (max-width: 767px) and (orientation: landscape) {
  .TD_JtFmIT0WGaT_0IEiI {
    background-size: cover;
  }
}
.cG7VJYsFYo5NM8_73UCi,
.zyQ3MgXXNLAok_zFEvze {
  position: absolute;
  bottom: 0;
  left: 50%;
  cursor: pointer;
  z-index: 2;
  display: block;
  aspect-ratio: 1 / 1;
}
.cG7VJYsFYo5NM8_73UCi {
  /* 108px tab → 0.62143 + 0.5/108 */
  transform: translate(-50%, 62.61%);
  background: none;
  border: none;
  padding: 0;
  width: var(--campaign-card-swipe-block-size);
  height: var(--campaign-card-swipe-block-size);
  pointer-events: auto;
}
.zyQ3MgXXNLAok_zFEvze {
  transform: translate(-50%, 80%);
  z-index: 3;
  width: var(--campaign-card-arrow-size);
  height: var(--campaign-card-arrow-size);
  transition: transform var(--campaign-transition-default);
  pointer-events: none;
}
.zyQ3MgXXNLAok_zFEvze.NPePe49ZjBwR3vDUz09a {
  transform: translate(-50%, 80%) rotate(180deg);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .uJUNzkOa3jVnmiel9OY3 {
    padding: var(--campaign-card-padding-mobile);
  }
  .zyQ3MgXXNLAok_zFEvze {
    width: var(--campaign-card-arrow-size-mobile);
    height: var(--campaign-card-arrow-size-mobile);
  }
  .cG7VJYsFYo5NM8_73UCi {
    width: var(--campaign-card-swipe-block-size-mobile);
    height: var(--campaign-card-swipe-block-size-mobile);
    /* 75px tab → 0.62143 + 0.5/75 */
    transform: translate(-50%, 62.81%);
  }
  .uJUNzkOa3jVnmiel9OY3.r1k5PwDmr936zh0xYLyS {
    height: var(--campaign-card-collapsed-height-mobile);
  }
}
/* Off-screen cards: kill all transitions so they snap to collapsed/expanded
   state instantly.  data-offscreen is set by IntersectionObserver on the
   ancestor .carouselItem — global attribute selector reaches across modules. */
[data-offscreen="true"] .uJUNzkOa3jVnmiel9OY3 {
  transition: none !important;
  animation: none !important;
}
[data-offscreen="true"] .TD_JtFmIT0WGaT_0IEiI {
  transition: none !important;
  animation: none !important;
}
[data-offscreen="true"] .gR4KQmZoGCYcuBbpl0A4 {
  animation: none !important;
}
/* Ingame styles */
[data-open-type='ingame'] [data-has-many='false'] .uJUNzkOa3jVnmiel9OY3 {
  width: calc(100% - (var(--campaign-card-ingame-margin) * 2));
  margin: 0 var(--campaign-card-ingame-margin);
}
@media (min-width: 1025px) and (max-width: 1150px) and (orientation: landscape) {
  [data-has-many='false'] .TD_JtFmIT0WGaT_0IEiI {
    background-size: cover;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  [data-open-type='ingame'] [data-has-many='false'] .uJUNzkOa3jVnmiel9OY3 {
    width: calc(100% - (var(--campaign-card-ingame-margin-mobile) * 2));
    margin: 0 var(--campaign-card-ingame-margin-mobile);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/defaults/CampaignCard/css/CampaignCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,mCAAmC;EACnC,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,+CAA+C;EAC/C,+CAA+C;EAC/C,+EAA+E;EAC/E;gFAC8E;EAC9E,qBAAqB;AACvB;AACA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,2FAA2F;EAC3F,+CAA+C;EAC/C,UAAU;AACZ;AACA;EACE,2FAA2F;AAC7F;AACA,0EAA0E;AAC1E;EACE,gBAAgB;AAClB;AACA;;sEAEsE;AACtE;EACE,uDAAuD;EACvD,+HAA+H;EAC/H,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;;;;;0EAK0E;AAC1E;EACE,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,qCAAqC;AACvC;AACA,gFAAgF;AAChF;EACE,oEAAoE;AACtE;AACA;EACE,4BAA4B;AAC9B;AACA;AAAA;EACE;IACE,WAAW;IACX,mDAAmD;EACrD;AACF;AAAA;AALA;AAAA;AAAA;AAAA;EACE;IACE,WAAW;IACX,mDAAmD;EACrD;AACF;AAAA;AAAA;AAAA;AACA;AAAA;EACE;IACE,WAAW;IACX,oDAAoD;IACpD,wBAAwB;EAC1B;AACF;AAAA;AANA;AAAA;AAAA;AAAA;EACE;IACE,WAAW;IACX,oDAAoD;IACpD,wBAAwB;EAC1B;AACF;AAAA;AAAA;AAAA;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,iDAAiD;EACjD,+CAA+C;AACjD;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;;sDAEsD;AACtD;EACE,UAAU;EACV,oBAAoB;EACpB,4BAA4B;AAC9B;AACA;EACE,yDAAiD;AACnD;AACA;AAAA;EACE;IACE,sBAAsB;EACxB;AACF;AAAA;AAJA;AAAA;AAAA;AAAA;EACE;IACE,sBAAsB;EACxB;AACF;AAAA;AAAA;AAAA;AACA;EACE;IACE,wBAAwB;EAC1B;AACF;AACA;AAAA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;AACF;AAAA;AAPA;AAAA;AAAA;AAAA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;AACF;AAAA;AAAA;AAAA;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;;EAEE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,eAAe;EACf,UAAU;EACV,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,4CAA4C;EAC5C,6CAA6C;EAC7C,oBAAoB;AACtB;AACA;EACE,+BAA+B;EAC/B,UAAU;EACV,sCAAsC;EACtC,uCAAuC;EACvC,wDAAwD;EACxD,oBAAoB;AACtB;AACA;EACE,8CAA8C;AAChD;AACA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;IAC7C,8CAA8C;EAChD;EACA;IACE,mDAAmD;IACnD,oDAAoD;IACpD,gCAAgC;IAChC,kCAAkC;EACpC;EACA;IACE,oDAAoD;EACtD;AACF;AACA;;+EAE+E;AAC/E;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA,kBAAkB;AAClB;EACE,4DAA4D;EAC5D,4CAA4C;AAC9C;AACA;EACE;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,mEAAmE;IACnE,mDAAmD;EACrD;AACF","sourcesContent":[".campaignCard {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  max-width: var(--campaign-card-max-width);\n  height: var(--campaign-card-height);\n  cursor: pointer;\n  padding: var(--campaign-card-padding);\n  flex-shrink: 0;\n  border: 1px solid var(--campaign-color-primary);\n  border-radius: var(--campaign-border-radius-md);\n  transition: transform 0.15s ease, height 0.35s cubic-bezier(0.22, 1.2, 0.36, 1);\n  /* Contain layout recalculations within the card during collapse animation.\n       This prevents the height transition from triggering layout on siblings. */\n  contain: layout style;\n}\n.campaignCard.collapsed {\n  height: var(--campaign-card-collapsed-height);\n  padding: var(--campaign-card-collapsed-padding);\n}\n.campaignCardShadow {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to top, var(--campaign-card-gradient-color) 0%, transparent 4%);\n  border-radius: var(--campaign-border-radius-md);\n  z-index: 0;\n}\n.campaignCardShadow[data-collapsed=\"true\"] {\n  background: linear-gradient(to top, var(--campaign-card-gradient-color) 0%, transparent 8%);\n}\n/* overflow: hidden clips content while scaleY animation is in progress. */\n.campaignCard[data-animating=\"true\"] {\n  overflow: hidden;\n}\n/* Dark background masking during COLLAPSE only.\n   On expand the new background image should be visible immediately.\n   data-collapsing is set by useCollapseAnimation only when folding. */\n.campaignCard[data-collapsing=\"true\"] {\n  background-color: var(--campaign-color-background-dark);\n  background-image: linear-gradient(135deg, var(--campaign-color-background-dark) 0%, var(--campaign-color-background-dark) 100%);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n/* Fade the background image out during collapse so the card's\n   dark background-color shows through (replicating the pre-release masking).\n   contain: layout style creates a stacking context, so z-index:-1 no longer\n   puts .backgroundImage behind the card's background — we hide it instead.\n   Hide is instant (0s) to avoid a flash of the new asset; reveal fades in\n   smoothly when data-collapsing is removed (base rule's 0.15s applies). */\n.campaignCard[data-collapsing=\"true\"][data-has-many=\"true\"] .backgroundImage {\n  opacity: 0;\n  transition: opacity 0s;\n}\n.campaignCard[data-has-many=\"true\"] .backgroundImage {\n  transition: opacity 0.15s ease-in-out;\n}\n/* Add background-color transition for hasMany so the dark mask fades smoothly */\n.campaignCard[data-has-many=\"true\"] {\n  transition: transform 0.15s ease, background-color 0.12s ease-in-out;\n}\n.campaignCard[data-animating=\"true\"] .backgroundImage {\n  background-repeat: no-repeat;\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .campaignCard {\n    width: 100%;\n    height: var(--campaign-card-height-mobile-portrait);\n  }\n}\n@media (--campaign-mobile) and (orientation: landscape) {\n  .campaignCard {\n    width: 100%;\n    height: var(--campaign-card-height-mobile-landscape);\n    background-size: contain;\n  }\n}\n.backgroundImage {\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: var(--campaign-card-background);\n  border-radius: var(--campaign-border-radius-sm);\n}\n@keyframes crossfadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n/* Outgoing layer for background crossfade during collapse/expand.\n   Sits on top of the current image (later in DOM order, same z-index)\n   and fades out to reveal the new image underneath. */\n.backgroundImageOutgoing {\n  opacity: 0;\n  pointer-events: none;\n  background-repeat: no-repeat;\n}\n.backgroundImageOutgoing[data-fading=\"true\"] {\n  animation: crossfadeOut 0.3s ease-in-out forwards;\n}\n@media (--campaign-mobile) and (orientation: portrait) {\n  .backgroundImage {\n    background-size: cover;\n  }\n}\n@media (--campaign-mobile-narrow) {\n  .backgroundImage[data-collapsed=\"true\"][data-has-many=\"true\"] {\n    background-size: contain;\n  }\n}\n@media (min-width: 500px) and (--campaign-mobile) and (orientation: portrait) {\n  .backgroundImage {\n    background-size: contain;\n  }\n  .backgroundImage[data-collapsed=\"true\"][data-has-many=\"false\"] {\n    background-size: cover;\n  }\n}\n@media (max-width: 767px) and (orientation: landscape) {\n  .backgroundImage {\n    background-size: cover;\n  }\n}\n.swipeBlock,\n.arrow {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  cursor: pointer;\n  z-index: 2;\n  display: block;\n  aspect-ratio: 1 / 1;\n}\n.swipeBlock {\n  /* 108px tab → 0.62143 + 0.5/108 */\n  transform: translate(-50%, 62.61%);\n  background: none;\n  border: none;\n  padding: 0;\n  width: var(--campaign-card-swipe-block-size);\n  height: var(--campaign-card-swipe-block-size);\n  pointer-events: auto;\n}\n.arrow {\n  transform: translate(-50%, 80%);\n  z-index: 3;\n  width: var(--campaign-card-arrow-size);\n  height: var(--campaign-card-arrow-size);\n  transition: transform var(--campaign-transition-default);\n  pointer-events: none;\n}\n.arrow.rotated {\n  transform: translate(-50%, 80%) rotate(180deg);\n}\n@media (--campaign-mobile) {\n  .campaignCard {\n    padding: var(--campaign-card-padding-mobile);\n  }\n  .arrow {\n    width: var(--campaign-card-arrow-size-mobile);\n    height: var(--campaign-card-arrow-size-mobile);\n  }\n  .swipeBlock {\n    width: var(--campaign-card-swipe-block-size-mobile);\n    height: var(--campaign-card-swipe-block-size-mobile);\n    /* 75px tab → 0.62143 + 0.5/75 */\n    transform: translate(-50%, 62.81%);\n  }\n  .campaignCard.collapsed {\n    height: var(--campaign-card-collapsed-height-mobile);\n  }\n}\n/* Off-screen cards: kill all transitions so they snap to collapsed/expanded\n   state instantly.  data-offscreen is set by IntersectionObserver on the\n   ancestor .carouselItem — global attribute selector reaches across modules. */\n[data-offscreen=\"true\"] .campaignCard {\n  transition: none !important;\n  animation: none !important;\n}\n[data-offscreen=\"true\"] .backgroundImage {\n  transition: none !important;\n  animation: none !important;\n}\n[data-offscreen=\"true\"] .backgroundImageOutgoing {\n  animation: none !important;\n}\n/* Ingame styles */\n[data-open-type='ingame'] [data-has-many='false'] .campaignCard {\n  width: calc(100% - (var(--campaign-card-ingame-margin) * 2));\n  margin: 0 var(--campaign-card-ingame-margin);\n}\n@media (min-width: 1025px) and (max-width: 1150px) and (orientation: landscape) {\n  [data-has-many='false'] .backgroundImage {\n    background-size: cover;\n  }\n}\n@media (--campaign-mobile) {\n  [data-open-type='ingame'] [data-has-many='false'] .campaignCard {\n    width: calc(100% - (var(--campaign-card-ingame-margin-mobile) * 2));\n    margin: 0 var(--campaign-card-ingame-margin-mobile);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignCard": `uJUNzkOa3jVnmiel9OY3`,
	"collapsed": `r1k5PwDmr936zh0xYLyS`,
	"campaignCardShadow": `cJFMO5f_TkEKJyCDMgEu`,
	"backgroundImage": `TD_JtFmIT0WGaT_0IEiI`,
	"backgroundImageOutgoing": `gR4KQmZoGCYcuBbpl0A4`,
	"crossfadeOut": `U8ULl2KQzBN18EKzssE5`,
	"swipeBlock": `cG7VJYsFYo5NM8_73UCi`,
	"arrow": `zyQ3MgXXNLAok_zFEvze`,
	"rotated": `NPePe49ZjBwR3vDUz09a`
};
export default ___CSS_LOADER_EXPORT___;
